var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mb-4 ml-4 align-center cursor-pointer",on:{"click":function($event){return _vm.$emit('to')}}},[_c(_setup.Icon,{staticClass:"custom-icon",attrs:{"color":_setup.iconColor,"name":_setup.props.icon,"size":"24"}}),(!_setup.isDrawerCollapsed())?_c('h3',{staticClass:"ml-4 font-size-14 font-grey font-weight-500",class:{
      'font-weight-bold': _setup.props.active,
      'font-weight-500': !_setup.props.active,
    },style:({ color: _setup.textColor })},[_vm._v(" "+_vm._s(_setup.props.name)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }